/**
 * @author Jersson Stiven Morales Alza
 * @Copyright (c) Infotrack. All rights reserved.
 */
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { Action, Column, Options } from '@infotrack/presentacion-componentes/tabla';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import IClientes from 'Infotrack@Modelos/smartStock/clientes/entidades/clientes';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const columnas = (
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string
): Array<Column<IClientes>> => [
    {
        title: formatMessage({ id: 'clientes.descripcionCliente' }),
        field: 'DescripcionCliente',
    },
    {
        title: formatMessage({ id: 'clientes.documento' }),
        field: 'Documento',
    },
    {
        title: formatMessage({ id: 'clientes.descripcionSucursal' }),
        field: 'DescripcionSucursal',
    },
    {
        title: formatMessage({ id: 'clientes.descripcionTipoCliente' }),
        field: 'DescripcionTipoCliente',
    },
    {
        title: formatMessage({ id: 'clientes.descripcionCiudad' }),
        field: 'DescripcionCiudad',
    },
    {
        title: formatMessage({ id: 'clientes.nombreContacto' }),
        field: 'NombreContacto',
    },
    {
        title: formatMessage({ id: 'clientes.telefono' }),
        field: 'Telefono',
    },
    {
        title: formatMessage({ id: 'clientes.direccion' }),
        field: 'Direccion',
    },
    {
        title: formatMessage({ id: 'clientes.correo' }),
        field: 'Correo',
    },
    {
        title: formatMessage({ id: 'clientes.codigoBarras' }),
        field: 'CodigoBarras',
    },
    {
        title: formatMessage({ id: 'clientes.diasVencimiento' }),
        field: 'DiasVencimiento',
    },
    {
        title: formatMessage({ id: 'clientes.principal' }),
        field: 'Principal',
        type: 'boolean',
    },
    {
        title: formatMessage({ id: 'clientes.estado' }),
        field: 'Estado',
        type: 'boolean',
    },
];

export const acciones = (
    manejarFormulario: (tipoFormulario: TipoFormulario, clientes?: IClientes) => void,
    cargarClientes: () => void,
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string,
    confirmarEliminacion: (clientes: IClientes) => void
): Array<Action<IClientes>> => [
    {
        icon: 'refresh',
        onClick: cargarClientes,
        isFreeAction: true,
        tooltip: formatMessage({ id: 'boton.refrescar' }),
    },
    {
        //component: BotonAgregar,
        // icon: () => <AddIcon />,
        icon: 'add',
        onClick: () => manejarFormulario(TipoFormulario.Creacion, undefined),
        isFreeAction: true,
        tooltip: formatMessage({ id: 'boton.agregar' }),
    },
    {
        icon: () => <EditIcon color="action" />,
        onClick: (_, value) => manejarFormulario(TipoFormulario.Edicion, value as IClientes),
        tooltip: formatMessage({ id: 'boton.editar' }),
    },
    {
        icon: () => <DeleteIcon color="action" />,
        onClick: (_, value) => confirmarEliminacion(value as IClientes),
        tooltip: formatMessage({ id: 'boton.eliminar' }),
    },
];

export const opciones: Options<IClientes> = {
    maxBodyHeight: '40vh',
};
